import script from "./AuraSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraSidebar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__